export default "__VITE_ASSET__132aad82__"